import script from "./AddIndexForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddIndexForm.vue?vue&type=script&setup=true&lang=js"

import "./AddIndexForm.vue?vue&type=style&index=0&id=4669571a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4669571a"]])

export default __exports__